import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from 'primeng/api';
import { NavMenuService } from '../../../core/components/navmenu/navmenu.service';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ProductosAtestFitoService } from './productosAtestFito.service';
import { SolicitudAtestFitoService } from '../datosbasicos/datosbasicosAtestFito.service';
import { TcPerfilUsuarioEnum, Tc } from '../../../core/_infrastructure/types/common';
import { SolicitudAtestFitoProductosViewModel, TProductoSolicitudAtestFitoViewModel } from './productosAtestFito.types';
import { EnumCodigosTwTcAcciones } from '../../../_importacion/solicitudes/types/enum';
import { Observable } from 'rxjs';

@Component({
    selector: 'app-productosatestfito-list',
    templateUrl: './productosAtestFito-list.component.html',
})
/** solicitud-edit component*/
export class ProductosAtestFitoListComponent extends ComponentBase implements OnInit {
    /** solicitud-edit ctor */

    editMode = false;
    editTitle = 'Nuevo';

    solicitudProductosAtestFito: SolicitudAtestFitoProductosViewModel;
    productosAtestFitoCollection: TProductoSolicitudAtestFitoViewModel[];
    tituloEstadoSolicitud: string;
    tituloTipoSolicitud: string;
    codigoTipoSolicitud: string;
    IdTipoSolicitudAtestFito: number;
    IdEstadoSolicitudAtestFito: number;
    refAtestFito: string;
    habilitarGuardar = true;
    habilitarNuevoProducto = true;
    habilitarEdicion = true;
    visibilitySpinner = false;
    campoObligatorio = true;
    sinProductos = false;
    idUnidadMedida: number | null = null;

    listTipoCantidad: Tc[];
    EsSolicitante: boolean;
    EsComunidad: boolean;
    EsAgenteControl: boolean;
    numeroProductos = 0;

    productoEditable: boolean;
    productoBorrable: boolean;

    colsProds: any[];

    constructor(
        public datepipe: DatePipe,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,

        protected authService: AuthService,
        protected notificacionService: NotificationService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private navMenuService: NavMenuService,
        private solicitudAtestFitoService: SolicitudAtestFitoService,
        private productosAtestFitoService: ProductosAtestFitoService,
    ) {
        super(authService, notificacionService, exceptionHandler);
    }

    ngOnInit() {
        let id = +this.activatedRoute.snapshot.params['id'];

        this.globalService.getTipoCantidad().subscribe(res => {
            this.listTipoCantidad = res;
        });

        this.guardRefreshPage(id);

        this.createForm();

        this.EsComunidad = this.isCA;
        this.EsAgenteControl = this.loggedInUser!.hasProfile(TcPerfilUsuarioEnum.AgenteControl);
        this.EsSolicitante = this.isSolicitante;

        if (id) {
            this.productosAtestFitoService.getSolicitudProductosAtestFito(id).subscribe(result => {
                this.solicitudProductosAtestFito = result;
                this.IdTipoSolicitudAtestFito = this.solicitudProductosAtestFito.IdTipoSolicitudAtestFito;
                this.tituloTipoSolicitud = this.solicitudProductosAtestFito.IdTipoSolicitudAtestFitoDescripcion;
                this.tituloEstadoSolicitud = this.solicitudProductosAtestFito.IdEstadoSolicitudAtestFitoDescripcion;
                this.codigoTipoSolicitud = this.solicitudProductosAtestFito.CodigoTipoSolicitud;
                this.IdEstadoSolicitudAtestFito = this.solicitudProductosAtestFito.IdEstadoSolicitudAtestFito;
                this.refAtestFito = this.solicitudProductosAtestFito.RefAtestFito;

                this.productosAtestFitoCollection = this.solicitudProductosAtestFito.TProductoSolicitudAtestFitoCollection;

                this.habilitarGuardar = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.GUARDAR_SOLICITUD_ATESTACION,
                    this.solicitudProductosAtestFito.IdEstadoSolicitudAtestFito,
                    undefined,
                ).Visible;
                this.habilitarNuevoProducto =
                    this.loggedInUser!.getAction(
                        EnumCodigosTwTcAcciones.MENU_PRODUCTOS_ATESTACION,
                        this.solicitudProductosAtestFito.IdEstadoSolicitudAtestFito,
                        undefined,
                    ).Editable && this.solicitudProductosAtestFito.IdTipoCantidadAtestFito != null;
                this.habilitarEdicion = this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.MENU_PRODUCTOS_ATESTACION,
                    this.solicitudProductosAtestFito.IdEstadoSolicitudAtestFito,
                ).Editable;

                this.updateForm();

                this.numeroProductos = this.solicitudProductosAtestFito.TProductoSolicitudAtestFitoCollection.length;

                if (!this.habilitarEdicion || this.numeroProductos > 0) {
                    //metodo para deshabilitar los controles
                    this.DisableControlsConsulta();
                    this.habilitarGuardar = false;
                } else if (this.habilitarEdicion && this.numeroProductos == 0) {
                    this.form.controls['SinProductos'].enable();
                }

                this.productoEditable = this.checkEdit();
                this.productoBorrable = this.checkDelete();
            });
        }

        //Cambios Productos
        this.colsProds = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'IdPaisDescripcion', header: 'País Origen' },
            { field: 'IdBotanicaDescripcion', header: 'Nom Cientí­fico' },
            { field: 'CodigoEppo', header: 'Cód. EPPO' },
            { field: 'NombreComun', header: 'Nombre Común' },
            { field: 'Grupo', header: 'Grupo' },
            { field: 'IdFormaDescripcion', header: 'Forma' },
            { field: 'Peso', header: 'Peso (Kg)' },
            { field: 'Unidades', header: 'Unidades (Ud)' },
            { field: 'Volumen', header: 'Volumen (m³)' },
        ];
    }

    createForm() {
        this.form = this.fb.group({
            SinProductos: false,
            IdTipoCantidadAtestFito: [null, Validators.required],
        });
    }

    updateForm() {
        this.form.setValue({
            SinProductos: this.solicitudProductosAtestFito.SinProductos,
            IdTipoCantidadAtestFito: this.solicitudProductosAtestFito.IdTipoCantidadAtestFito,
        });

        this.sinProductos = this.solicitudProductosAtestFito.SinProductos;
        this.idUnidadMedida = this.solicitudProductosAtestFito.IdTipoCantidadAtestFito;

        this.gestionControlesSinProductos();
    }

    guardRefreshPage(id: number) {
        if ((id && !this.navMenuService.currentSolicitudAtestacion.Id) || this.navMenuService.currentSolicitudAtestacion.Id !== id) {
            this.solicitudAtestFitoService.getSolicitudAtestFito(id).subscribe(result => {
                this.navMenuService.currentSolicitudAtestacion = result;
            });
        }
    }

    checkEdit() {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_PRODUCTOS_ATESTACION, this.solicitudProductosAtestFito.IdEstadoSolicitudAtestFito)
            .Editable;
    }

    checkDelete() {
        return this.loggedInUser!.getAction(EnumCodigosTwTcAcciones.MENU_PRODUCTOS_ATESTACION, this.solicitudProductosAtestFito.IdEstadoSolicitudAtestFito)
            .Editable;
    }

    DisableControlsConsulta() {
        this.form.controls['SinProductos'].disable();
        this.form.controls['IdTipoCantidadAtestFito'].disable();
    }

    EnableControls() {
        this.form.controls['SinProductos'].enable();
        this.form.controls['IdTipoCantidadAtestFito'].enable();
    }

    guardarSolicitud() {
        this.confirmationService.confirm({
            message: 'Va a guardar datos de la solicitud, ¿desea continuar?',
            accept: () => {
                this.onSubmit();
            },
        });
    }

    onAdd() {
        this.router.navigate(['/exportacion/atestacion/productos/', this.solicitudProductosAtestFito.Id, 'create']);
    }

    onEdit(item: SolicitudAtestFitoProductosViewModel) {
        this.router.navigate(['/exportacion/atestacion/productos', this.solicitudProductosAtestFito.Id, 'producto', item.Id]);
    }

    onDelete(item: TProductoSolicitudAtestFitoViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.productosAtestFitoService.deleteSolicitudProductosAtestFito(item.Id).subscribe(res => {
                    this.addSuccessMessage('Producto eliminado correctamente');
                    this.ngOnInit();
                });
            },
        });
    }

    onSelectTipoCantidad() {
        this.idUnidadMedida = this.form.value.IdTipoCantidadAtestFito;
    }

    onSelectedSinProductos() {
        this.sinProductos = this.form.value.SinProductos;
        this.gestionControlesSinProductos();
    }

    gestionControlesSinProductos() {
        if (this.form.value.SinProductos) {
            this.form.controls['IdTipoCantidadAtestFito'].disable();
            this.idUnidadMedida = null;
            this.habilitarNuevoProducto = false;
            this.removeValidators('IdTipoCantidadAtestFito');
            this.campoObligatorio = false;

            this.form.patchValue({
                IdTipoCantidadAtestFito: null,
            });
        } else {
            this.addValidator('IdTipoCantidadAtestFito', Validators.required);
            this.campoObligatorio = true;
            this.form.controls['IdTipoCantidadAtestFito'].enable();
            this.habilitarNuevoProducto =
                this.loggedInUser!.getAction(
                    EnumCodigosTwTcAcciones.MENU_PRODUCTOS_ATESTACION,
                    this.solicitudProductosAtestFito.IdEstadoSolicitudAtestFito,
                    undefined,
                ).Editable && this.solicitudProductosAtestFito.IdTipoCantidadAtestFito != null;
        }
    }

    onSubmit() {
        this.submitted = true;

        if (!this.form.valid) {
            return;
        }

        this.visibilitySpinner = true;

        let solicitudProductosAtestFito = new SolicitudAtestFitoProductosViewModel();

        solicitudProductosAtestFito.SinProductos = this.sinProductos;
        solicitudProductosAtestFito.IdTipoCantidadAtestFito = this.idUnidadMedida;
        solicitudProductosAtestFito.Id = this.solicitudProductosAtestFito.Id;

        this.productosAtestFitoService.editSolicitudProductosAtestFito(solicitudProductosAtestFito).subscribe({
            next: res => {
                this.addSuccessMessage('Solicitud guardada correctamente');
                //this.router.navigate(["/exportacion/solicitud/productosEx/" + this.solicitudProductosAtestFito.Id]);
                //this.onBack();
                this.visibilitySpinner = false;
                this.ngOnInit();
            },
            error: error => {
                this.catchServerError(error);
                this.visibilitySpinner = false;
            },
        });
    }
}
